import axios from "axios";
import { ADMIN_API_URL, SERVICE_NAME } from "../config/serviceConstant";
// import { ADMIN_API_URL } from "../config/serviceConstant";

export const getServiceAuthUrl = async (headers, service) => {
  try {
    const config = {
      method: "POST",
      url: ADMIN_API_URL + "/auth/authenticator/authenticate",
      headers: headers,
      data: {
        orgId: headers?.orgId,
        apiKey: headers?.apiKey,
        zapiKey: headers?.zApiKey,
        connName: headers?.connName,
        accountsUrl: service?.authorizeUrl,
        scope: service?.scopes || service?.scope,
        redirectUrl: service?.serverCallbackUrl,
        crmApiDomain: service?.crmApiDomain,
        clientId: service?.clientId,
        authType: service?.authType,
        clientSecret: service?.clientSecret,
        scopeSeperator: service?.scopeSeperator,
        settingId: service?.settingId,
        queryParams: service?.queryParams,
      },
      params: service?.queryParams,
    };

    const authUrlResp = await axios(config);
    return authUrlResp?.data?.authUrl;
  } catch (error) {
    return null;
  }
};

export const checkServiceAuth = async (serviceHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/authenticator/verifyauth",
      headers: serviceHeaders,
    };

    const authCheck = await axios(config);

    if (!authCheck?.data || authCheck?.error || authCheck?.data?.error) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export const revokeService = async (serviceHeaders, service) => {
  try {
    const config = {
      method: "get",
      url: service?.serverRevokeUrl,
      headers: serviceHeaders,
    };

    const revokeCheck = await axios(config);

    if (revokeCheck?.data || !revokeCheck?.error) return true;
    return false;
  } catch (error) {
    return false;
  }
};

export const authenticateService = async ({ serviceApiKey, headers }) => {
  return true;
  // const config = {
  //   url: ADMIN_API_URL + "/auth/" + SERVICE_NAME + "/authenticate",
  //   method: "post",
  //   data: {
  //     serviceApiKey: serviceApiKey,
  //   },
  //   headers: headers,
  // };

  // const authServiceResp = await axios(config);

  // if (authServiceResp?.data?.data) {
  //   return true;
  // }
  // return false;
};

export const getAllConnections = async ({ headers }) => {
  try {
    const config = {
      url: ADMIN_API_URL + "/utils/connections",
      method: "get",
      headers: headers,
    };

    const authServiceResp = await axios(config);

    return authServiceResp?.data?.tokenResps;
  } catch (error) {}
};

export const sendInvitalionLink = async ({ zapiKey, data }) => {
  let url = `https://plugin-easyauthenticator.zohosandbox.com/crm/v2/functions/easyauthenticator__send_invitation_mail/actions/execute?auth_type=apikey&zapikey=1001.d8c9461adbe6404a6a75adb538530cad.103554dd33424d3ec758705c09dd58c7`;
  // url = `https://www.zohoapis.com/crm/v2/functions/easyauthenticator__send_invitation_mail/actions/execute?auth_type=apikey&zapikey=${zapiKey}`,
  url =
    "https://www.zohoapis.com/crm/v2/functions/send_authentication_link/actions/execute?auth_type=apikey&zapikey=1003.69377e4c023746b678620c179deee294.eff03852627bfad3ec15cdb073c2e8b3";
  try {
    const config = {
      url: url,
      method: "post",
      headers: {
        "Content-type": "application/json",
      },
      data: data,
    };

    const sendInviationResp = await axios(config);

    return sendInviationResp;
  } catch (error) {}
};
